__turbopack_context__.v({
  "bgTexture": "style-module-scss-module__0OiPda__bgTexture",
  "content": "style-module-scss-module__0OiPda__content",
  "contentBlock": "style-module-scss-module__0OiPda__contentBlock",
  "isCalendlyFirst": "style-module-scss-module__0OiPda__isCalendlyFirst",
  "isCalendlySecond": "style-module-scss-module__0OiPda__isCalendlySecond",
  "section": "style-module-scss-module__0OiPda__section",
  "video": "style-module-scss-module__0OiPda__video",
});
